var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "insider-of-aside"
  }, [_c("el-carousel", {
    attrs: {
      trigger: "click",
      height: "800px"
    }
  }, _vm._l(_vm.iSubeSlidingWindowUrl, function (item) {
    return _c("el-carousel-item", {
      key: item.webSplashId
    }, [_c("h3", {
      staticClass: "small"
    }, [(_vm.imageLoaded = true) ? _c("img", {
      staticStyle: {
        width: "100%",
        cursor: "pointer"
      },
      attrs: {
        src: _vm.getImagePath(item)
      },
      on: {
        click: function click($event) {
          return _vm.clicks(item);
        }
      }
    }) : _vm._e()])]);
  }), 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };